import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=481c93b7&scoped=true&"
import script from "./Tab.ts?vue&type=script&lang=ts&"
export * from "./Tab.ts?vue&type=script&lang=ts&"
import style0 from "./Tab.vue?vue&type=style&index=0&id=481c93b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c93b7",
  null
  
)

component.options.__file = "Tab.vue"
export default component.exports